import { loginRequest } from '../Config/msalConfig';

class AuthService {
  constructor() {
    this.msalInstance = null;
  }

  setMsalInstance(instance) {
    this.msalInstance = instance;
  }

  getMsalInstance() {
    return this.msalInstance;
  }

  getAccount() {
    if (!this.msalInstance) return null;
    const accounts = this.msalInstance.getAllAccounts();
    return accounts.length > 0 ? accounts[0] : null;
  }

  // Try silent token acquisition first, fallback to interactive popup
  async acquireToken() {
    if (!this.msalInstance) {
      throw new Error('MSAL instance not initialized');
    }

    const account = this.getAccount();
    if (!account) {
      throw new Error('No active account');
    }

    const tokenRequest = {
      ...loginRequest,
      account: account,
    };

    try {
      const response = await this.msalInstance.acquireTokenSilent(tokenRequest);
      return response.accessToken;
    } catch (error) {
      console.warn('Silent token acquisition failed, attempting interactive:', error);
      const response = await this.msalInstance.acquireTokenPopup(tokenRequest);
      return response.accessToken;
    }
  }

  async login() {
    if (!this.msalInstance) {
      throw new Error('MSAL instance not initialized');
    }
    await this.msalInstance.loginRedirect(loginRequest);
  }

  async logout() {
    if (!this.msalInstance) {
      throw new Error('MSAL instance not initialized');
    }
    
    const account = this.getAccount();
    const logoutRequest = {
      account: account,
    };
    
    await this.msalInstance.logoutRedirect(logoutRequest);
  }

  isAuthenticated() {
    return this.getAccount() !== null;
  }
}

export const authService = new AuthService();
